import { useState } from 'react';

import { clienteD3Api } from '../services/api/cliente-d3.api';
import { ClienteD3Response, ToggleD3Payload } from '../types/cliente-d3';

export const useClienteD3 = (clienteId: string) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const toggle = async (
    payload: ToggleD3Payload,
  ): Promise<ClienteD3Response | null> => {
    setLoading(true);
    setError(null);
    try {
      const result = await clienteD3Api.toggle(clienteId, payload);
      return result;
    } catch (err: unknown) {
      const message =
        err instanceof Error ? err.message : 'Erro ao atualizar D+3';
      setError(message);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { toggle, loading, error, clearError: () => setError(null) };
};
